import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@mui/material';
import React, { useState } from 'react';
import { Typography, IconButton, Icon } from '@elements';
import EventTicket from '@components/event-ticket';
import { Link } from 'react-router-dom';
import { useEventSessionsPage } from '@hooks/useEventSessions';
import { SEASON_PASS_EVENT_CONSIST_TYPES } from '@api/event-session';
import PrevIcon from '@images/prev.svg';
import NextIcon from '@images/next.svg';
import Loader from '@components/loader/Loader';
import num_word from '@utils/num_word';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PAGE_SIZE = 20;
var normalizeEventSession = function normalizeEventSession(event) {
  var _event$seats, _event$eventSessionTy;
  return _objectSpread(_objectSpread({}, event), {}, {
    seats: (_event$seats = event.seats) !== null && _event$seats !== void 0 ? _event$seats : [],
    eventSessionTypeName: (_event$eventSessionTy = event.eventSessionTypeName) !== null && _event$eventSessionTy !== void 0 ? _event$eventSessionTy : event.eventTypeName
  });
};
var SeasonPassTickets = function SeasonPassTickets() {
  var _data$content, _data$totalPages, _data$totalPages2;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pageNumber = _useState2[0],
    setPageNumber = _useState2[1];
  var _useEventSessionsPage = useEventSessionsPage(SEASON_PASS_EVENT_CONSIST_TYPES, pageNumber, PAGE_SIZE),
    data = _useEventSessionsPage.data,
    isFetching = _useEventSessionsPage.isFetching;
  var content = (_data$content = data === null || data === void 0 ? void 0 : data.content) !== null && _data$content !== void 0 ? _data$content : [];
  var hasNextPage = ((_data$totalPages = data === null || data === void 0 ? void 0 : data.totalPages) !== null && _data$totalPages !== void 0 ? _data$totalPages : 0) > 0 && pageNumber < ((_data$totalPages2 = data === null || data === void 0 ? void 0 : data.totalPages) !== null && _data$totalPages2 !== void 0 ? _data$totalPages2 : 1) - 1;
  var hasPrevPage = pageNumber > 0;
  var handleNextPage = function handleNextPage() {
    if (hasNextPage) setPageNumber(function (p) {
      return p + 1;
    });
  };
  var handlePrevPage = function handlePrevPage() {
    if (hasPrevPage) setPageNumber(function (p) {
      return p - 1;
    });
  };
  if (isFetching && content.length === 0) {
    return /*#__PURE__*/_jsx(Loader, {
      isShowLoader: true
    });
  }
  var seatsCount = content.reduce(function (acc, es) {
    var _es$seats;
    return acc + ((_es$seats = es.seats) !== null && _es$seats !== void 0 ? _es$seats : []).length;
  }, 0);
  if (!data || content.length === 0) {
    return /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        color: "white",
        fontSize: 22,
        sx: {
          mb: '26px'
        },
        children: ["\u0423 \u0432\u0430\u0441 0 ", num_word(0, ['абонемент', 'абонемента', 'абонементов']), " \u0438 0", ' ', num_word(0, ['место', 'места', 'мест'])]
      }), /*#__PURE__*/_jsx(Typography, {
        children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      maxWidth: '414px'
    },
    children: [/*#__PURE__*/_jsxs(Typography, {
      color: "white",
      fontSize: 22,
      sx: {
        mb: '26px'
      },
      children: ["\u0423 \u0432\u0430\u0441 ", content.length, ' ', num_word(content.length, ['абонемент', 'абонемента', 'абонементов']), " \u0438 ", seatsCount, ' ', num_word(seatsCount, ['место', 'места', 'мест'])]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '16px'
      },
      children: content.map(function (eventSession) {
        return /*#__PURE__*/_jsx(Link, {
          style: {
            textDecoration: 'none'
          },
          to: "events/".concat(eventSession.id),
          children: /*#__PURE__*/_jsx(EventTicket, {
            event: normalizeEventSession(eventSession)
          })
        }, eventSession.id);
      })
    }), data.totalPages > 1 && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        mt: '24px',
        mb: '24px'
      },
      children: [/*#__PURE__*/_jsx(IconButton, {
        onClick: handlePrevPage,
        disabled: !hasPrevPage,
        sx: {
          opacity: hasPrevPage ? 1 : 0.5,
          cursor: hasPrevPage ? 'pointer' : 'not-allowed'
        },
        children: /*#__PURE__*/_jsx(Icon, {
          src: PrevIcon,
          width: 24,
          height: 24
        })
      }), /*#__PURE__*/_jsxs(Typography, {
        children: [pageNumber + 1, " / ", data.totalPages]
      }), /*#__PURE__*/_jsx(IconButton, {
        onClick: handleNextPage,
        disabled: !hasNextPage,
        sx: {
          opacity: hasNextPage ? 1 : 0.5,
          cursor: hasNextPage ? 'pointer' : 'not-allowed'
        },
        children: /*#__PURE__*/_jsx(Icon, {
          src: NextIcon,
          width: 24,
          height: 24
        })
      })]
    })]
  });
};
export default SeasonPassTickets;